import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'instant' });
    if (!isHomePage) {
      window.location.href = '/';
    }
  };

  const scrollToSection = (id) => {
    if (!isHomePage) {
      window.location.href = `/#${id}`;
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 100;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 inset-x-0 z-50 bg-white/95 backdrop-blur supports-[backdrop-filter]:backdrop-blur border-b border-border shadow-sm">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a
          href="/"
          onClick={handleLogoClick}
          className="flex items-center gap-3 cursor-pointer"
          data-testid="nav-brand-link"
        >
          <img src="/assets/logo-white.png" alt="Elite Roofing and Construction" className="h-16 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-7 text-sm font-medium text-slate-700">
          <button onClick={() => scrollToSection('services')} className="hover:text-[hsl(var(--primary))] transition-colors">Services</button>
          <Link to="/residential-services" className="hover:text-[hsl(var(--primary))] transition-colors">Residential</Link>
          <Link to="/commercial-services" className="hover:text-[hsl(var(--primary))] transition-colors">Commercial</Link>
          <Link to="/insurance-claims" className="hover:text-[hsl(var(--primary))] transition-colors">Insurance Claims</Link>
          <Link to="/careers" className="hover:text-[hsl(var(--primary))] transition-colors" data-testid="nav-careers-link">Careers</Link>
          <Link to="/contact" className="hover:text-[hsl(var(--primary))] transition-colors" data-testid="nav-contact-link">Contact</Link>
          <button onClick={() => scrollToSection('reviews')} className="hover:text-[hsl(var(--primary))] transition-colors">Reviews</button>
          <button onClick={() => scrollToSection('about')} className="hover:text-[hsl(var(--primary))] transition-colors">About</button>
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <Button
            onClick={scrollToTop}
            className="h-11 px-6 bg-[hsl(var(--accent))] text-white hover:bg-[#a01830] transition-colors shadow-lg font-semibold"
            data-testid="nav-certification-button"
          >
            Schedule Free Inspection
          </Button>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden border-t border-border bg-white">
          <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8 py-4">
            <nav className="flex flex-col gap-3 text-base">
              <button onClick={() => scrollToSection('services')} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2">Services</button>
              <Link to="/residential-services" onClick={() => setMobileMenuOpen(false)} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2">Residential</Link>
              <Link to="/commercial-services" onClick={() => setMobileMenuOpen(false)} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2">Commercial</Link>
              <Link to="/insurance-claims" onClick={() => setMobileMenuOpen(false)} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2">Insurance Claims</Link>
              <Link to="/careers" onClick={() => setMobileMenuOpen(false)} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2" data-testid="mobile-nav-careers-link">Careers</Link>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2" data-testid="mobile-nav-contact-link">Contact</Link>
              <button onClick={() => scrollToSection('reviews')} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2">Reviews</button>
              <button onClick={() => scrollToSection('about')} className="text-left text-slate-700 hover:text-[hsl(var(--primary))] transition-colors py-2">About</button>
              <Button
                onClick={scrollToTop}
                className="mt-1 bg-[hsl(var(--accent))] text-white hover:bg-[#a01830] font-semibold"
                data-testid="mobile-nav-certification-button"
              >
                Schedule Free Inspection
              </Button>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}
